module.exports = __webpack_public_path__ + "static/img/advantage5.6a2965ea.png";